import styled from 'styled-components';

export const ResponsiveShell = styled.div`
  width: 100vw;
  height: var(--app-height, 100dvh);
  background: #F9F6E8;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
`;
